import React from "react";
import {observer} from "mobx-react";
import useToggleState from "components/hooks/useToggleState";
import ModalPopup, {ModalPopupProps} from "components/modal";
import commonPopupStore from "../store/CommonPopupStore";
import Button from "components/buttons";

export interface AlertElecConfirmPopupParam {
    message: string | React.JSX.Element;
    confirm: boolean;
    callback?: (value: boolean) => void;
    size?: ModalPopupProps["size"];
    className?: ModalPopupProps["className"];
}

export default observer(AlertElecConfirmPopup);

function AlertElecConfirmPopup({message, confirm, callback, size = 'alert', className}: AlertElecConfirmPopupParam) {
    const modalState = useToggleState({showing: true});

    const handleOk = () => {
        (async () => modalState.toggle())();
        callback && (async () => callback(true))();
    };
    const handleCancel = () => {
        (async () => modalState.toggle())();
        callback && (async () => callback(false))();
    };


    const handleClose = () => {
        if (confirm)
            handleCancel();
        else
            handleOk();
    }

    return (
        <ModalPopup
            open={modalState.isShowing}
            title={''}
            size={size}
            className={className}
            onClose={handleClose}
            onAfterClose={() => {
                commonPopupStore.closeLastPopup()
            }}
            onRequestClose={handleClose}
        >
            <div className="modal-con">
                {message}
            </div>
            <div className="modal-bottom">
                {confirm && <Button color='gray-o' size="md" onClick={handleCancel}>서면 인증</Button>}
                <Button color='pri' size="md" onClick={handleOk}>전자 인증</Button>
            </div>
        </ModalPopup>
    )
}
